import type { SectionState } from '../store/editor.store'

export function uid() {
  return `tmpl-${Math.random().toString(36).slice(2, 9)}`
}

export function sec(blocks: SectionState['blocks'], opts: Partial<SectionState> = {}): SectionState {
  return {
    id: uid(),
    blocks,
    paddingTop: 0,
    paddingBottom: 0,
    background: 'transparent',
    ...opts,
  }
}

export function blk(type: string, data: Record<string, unknown>) {
  return { id: uid(), type, data }
}
